// Import GSAP (add this to your HTML or use a module bundler)
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js"></script>
// <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js"></script>

const parallaxImages = () => {
  // Register ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  const images = document.querySelectorAll(".parallax-image");

  images.forEach((image) => {
    const container = image.parentElement;

    // Create GSAP timeline for smooth scaling
    gsap.set(image, {
      scale: 1.15,
      force3D: true, // Enable hardware acceleration
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: container,
        start: "top bottom", // Animation starts when top of container hits bottom of viewport
        end: "bottom top", // Animation ends when bottom of container hits top of viewport
        scrub: 0.5, // Smooth scrubbing effect (adjust value for different smoothness)
        markers: false, // Set to true for debugging
        onEnter: () => (image.style.willChange = "transform"),
        onLeave: () => (image.style.willChange = "auto"),
        onEnterBack: () => (image.style.willChange = "transform"),
        onLeaveBack: () => (image.style.willChange = "auto"),
      },
    });

    // Add scale animation
    tl.fromTo(image, { scale: 1.15 }, { scale: 1, ease: "none" });
  });
};

const animateAnnouncementBar = () => {
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (!announcementBar) return;

  // Set initial state
  gsap.set(announcementBar, {
    y: -50, // Start 50px above
    opacity: 0,
    force3D: true // Enable hardware acceleration
  });

  // Create reveal animation
  gsap.to(announcementBar, {
    y: 0, // Slide down to original position
    opacity: 1,
    duration: 0.8,
    ease: 'power2.out',
    onStart: () => announcementBar.style.willChange = 'transform, opacity',
    onComplete: () => announcementBar.style.willChange = 'auto'
  });
};

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', animateAnnouncementBar);

const parallaxSections = () => {
  // Get all parallax sections
  const sections = document.querySelectorAll(".parallax-section");

  sections.forEach((section) => {
    // Set initial state
    gsap.set(section, {
      force3D: true, // Enable hardware acceleration
    });

    // Create animation
    gsap.to(section, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section,
        start: "top bottom", // Start as soon as section enters viewport
        end: "top center", // End when top of section reaches center
        toggleActions: "play none none reverse",
        markers: false,
        onEnter: () => (section.style.willChange = "transform, opacity"),
        onLeave: () => (section.style.willChange = "auto"),
        onEnterBack: () => (section.style.willChange = "transform, opacity"),
        onLeaveBack: () => (section.style.willChange = "auto"),
      },
    });
  });
};

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", parallaxImages);
document.addEventListener("DOMContentLoaded", parallaxSections);

// Re-run parallax sections on Shopify Theme Editor events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', parallaxSections);
  document.addEventListener('shopify:section:reorder', parallaxSections);
  document.addEventListener('shopify:section:select', parallaxSections);
  document.addEventListener('shopify:section:deselect', parallaxSections);
}


const addButtonHoverEffects = () => {
  const buttons = document.querySelectorAll("button, .button");

  buttons.forEach((button) => {
    button.addEventListener("mouseenter", (e) => {
      // Remove any existing directional classes
      button.classList.remove(
        "from-top",
        "from-right",
        "from-bottom",
        "from-left"
      );

      // Get button's bounding box
      const rect = button.getBoundingClientRect();

      // Calculate mouse position relative to button center
      const x = e.clientX - (rect.left + rect.width / 2);
      const y = e.clientY - (rect.top + rect.height / 2);

      // Determine which edge was entered from based on angle
      const angle = (Math.atan2(y, x) * 180) / Math.PI;

      // Add appropriate class based on entry angle
      if (angle >= -45 && angle < 45) {
        button.classList.add("from-right");
      } else if (angle >= 45 && angle < 135) {
        button.classList.add("from-bottom");
      } else if (angle >= 135 || angle < -135) {
        button.classList.add("from-left");
      } else {
        button.classList.add("from-top");
      }
    });

    button.addEventListener("mouseleave", () => {
      // Remove all directional classes on mouse leave
      button.classList.remove(
        "from-top",
        "from-right",
        "from-bottom",
        "from-left"
      );
    });
  });
};

// Initialize on DOM load
document.addEventListener("DOMContentLoaded", addButtonHoverEffects);

class LoadingBar extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("beforeunload", () => {
      this.animate({ opacity: [0, 1] }, { duration: 400 });
      document.body.classList.add("unloading");
    });

    window.addEventListener("DOMContentLoaded", () => {
      this.animate({ opacity: [1, 0] }, { duration: 400 }).onfinish = () => {
        this.style.visibility = "hidden";
      };

      document.body.classList.add("loaded");
      document.dispatchEvent(new CustomEvent("page:loaded"));
    });

    window.addEventListener("pageshow", (event) => {
      // Removes unload class when returning to page via history
      if (event.persisted) {
        document.body.classList.remove("unloading");
      }
    });
  }
}
customElements.define("loading-bar", LoadingBar);

const initVerticalMarquee = () => {
  const marquees = document.querySelectorAll('.vertical-marquee');
  
  marquees.forEach(marquee => {
    // Store original children
    const originalChildren = Array.from(marquee.children);
    if (!originalChildren.length) return;

    // Calculate total height of original content
    const contentHeight = originalChildren.reduce((acc, child) => 
      acc + child.offsetHeight, 0);

    // Set marquee styles
    gsap.set(marquee, {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      force3D: true,
    });

    // Create two sets of content for seamless loop
    originalChildren.forEach(child => {
      // skip if child is not a button
      const clone = child.cloneNode(true);
      clone.querySelector('x-popover')?.remove();
      marquee.appendChild(clone);
    });

    // Create the infinite scroll animation
    const animate = () => {
      const tl = gsap.timeline({
        repeat: -1
      });

      // Main scroll sequence
      tl.to(marquee, {
        y: `-=${contentHeight}`,
        duration: 10,
        ease: 'none'
      })
      // Start fade out while continuing scroll
      .to(marquee, {
        opacity: 0,
        duration: 2,
        ease: 'none'
      }, ">-2")
      // Reset position and start new scroll immediately
      .set(marquee, { y: 0 })
      .to(marquee, {
        y: `-=${contentHeight}`,
        duration: 10,
        ease: 'none'
      }, "<")
      // Fade back in while scrolling
      .to(marquee, {
        opacity: 1,
        duration: 2,
        ease: 'none'
      }, "<");

      return tl;
    };

    // Start animation
    const animation = animate();

    // Add hover effect with smooth transitions
    let isHovered = false;
    marquee.addEventListener('mouseenter', () => {
      if (isHovered) return;
      isHovered = true;
      gsap.to(animation, {
        timeScale: 0,
        duration: 0.5,
        ease: 'power2.out'
      });
    });

    marquee.addEventListener('mouseleave', () => {
      if (!isHovered) return;
      isHovered = false;
      gsap.to(animation, {
        timeScale: 1,
        duration: 1,
        ease: 'power2.in'
      });
    });

    // Cleanup on section unload
    if (Shopify.designMode) {
      marquee.parentElement.addEventListener('shopify:section:unload', () => {
        animation.kill();
      });
    }
  });
};

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', initVerticalMarquee);

// Re-initialize on Shopify Theme Editor events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', initVerticalMarquee);
  document.addEventListener('shopify:section:select', initVerticalMarquee);
}
